import styled, { css } from 'styled-components';

export const Container = styled.div`
  margin-left: 16px;
  min-width: 60px;
  min-height: 60px;
  background: #EFEFEF;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
  cursor: pointer;

  ${({noMargin}) => noMargin && css`
    margin-left: 0;
  `}

  ${({ isLink }) => isLink && css`
    background-color: #0B29FB;
  `}

  ${({ noAction }) => noAction && css`
    cursor-pointer: not-allowed;
  `}
`
